import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'
import Dropzone from 'react-dropzone'
import { toast } from 'react-toastify'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'

import {
    showHideModalAddFactura,
    updateInputs,
    uploadFacturaFile,
    storeFactura,
    showHideModalLastFactura
} from '../../actions/common'


import { acceptedFiles } from '../../utils/helpers'
const filesTypes = acceptedFiles.map(x => x.type).join()


class ModalAddFactura extends Component {

    handleCloseModal = () => {
        
        const modal = document.getElementById('modalAddFactura')
        modal.classList.remove('fadeIn')
        modal.classList.add('fadeOut')

        const modalDialog = document.querySelector(`#modalAddFactura .modal-dialog`)
        modalDialog.classList.remove('zoomIn')
        modalDialog.classList.add('zoomOut')

        setTimeout(() => this.props.showHideModalAddFactura(false), 300)
    }

    handleOnDrop = (files) => {
        if (files.length > 1) {
            toast.warn(`Solo es permitido procesar un archivo a la vez`, { bodyClassName: 'toastify-content toastify-warning' })
            return
        }
        this.props.uploadFacturaFile(files[0])
    }

    handleOnRejected = (files) => {
        files.forEach(x => {
            toast.warn(`El archivo ${x.name} no es del tipo esperado. ${x.type}`, { bodyClassName: 'toastify-content toastify-warning' })
        })
    }

	setIcon = (icon) => {
		if (icon) {
			const imageSrc = require('../../img/16px/' + icon)
			return <img src={ imageSrc } />
		}
		return null
	}

    render() {
        const { modalAddFactura } = this.props
        if (!modalAddFactura.get('show')) {
            return null
        }




        return(
            <Modal id="modalAddFactura" show={ true } ZIndex={ 2000 }>
                <ModalHeader title={ `Adición de facturas al documento` } onClose={ e => this.handleCloseModal(e, "modalAddFactura") } />
                <ModalButtonStrip>
                    <BoxButton
                        name="floppy-o"
                        title="Guardar"
                        onClick={ e => this.props.showHideModalLastFactura(true, this.props.storeFactura) }
                        disabled ={modalAddFactura.get('btnDisabled')}                      
                    />
                </ModalButtonStrip>
                <ModalBody>
                    <div style={{ width: '600px' }}>
						<div className="row">
							<div className="col-md-12">
                                <Dropzone accept={ filesTypes } onDropAccepted={ this.handleOnDrop } onDropRejected={ this.handleOnRejected } className="dropzone1">
                                    <p>Arrastre la factura escaneada a esta sección</p>
                                </Dropzone>
							</div>
						</div>
						<div className="row" style={{ marginTop: '10px' }}>
							<div className="col-md-12">
								<div className="form-group">
									<label className="control-label">Nombre del archivo</label>
									<div className="div-input-sm">
										{
											(modalAddFactura.getIn(['data', 'file']) &&
												<div style={{ paddingTop: '1px' }}>
													<span>{ this.setIcon(modalAddFactura.getIn(['data', 'icono'])) }</span>
													<span style={{ marginLeft: '4px', verticalAlign: 'bottom' }}>{ modalAddFactura.getIn(['data', 'file']).name }</span>
													<span style={{ marginLeft: '3px', verticalAlign: 'bottom', color: '#ccc' }}>({ numeral(modalAddFactura.getIn(['data', 'file']).size).format('0.0 b') })</span>
												</div>
											)
										}
									</div>
								</div>
							</div>
						</div>
                        <div className="row">
                            <div className="col-md-3">
								<div className="form-group">
									<label className="control-label">Factura número</label>
									<input type="text" className="form-control input-sm" value={ modalAddFactura.getIn(['data', 'numero_factura']) } onChange={ (e) => this.props.updateInputs('modalAddFactura.data.numero_factura', e.target.value) } />
								</div>
                            </div>
                            <div className="col-md-3">
								<div className="form-group">
									<label className="control-label">Fecha de la factura</label>
									<input type="date" className="form-control input-sm" value={ moment(modalAddFactura.getIn(['data', 'fecha_factura'])).format('YYYY-MM-DD') } onChange={ (e) => this.props.updateInputs('modalAddFactura.data.fecha_factura', e.target.value) } />
								</div>
                            </div>
                            <div className="col-md-3">
								<div className="form-group">
									<label className="control-label">Valor sin IVA</label>
									<input type="number" className="form-control input-sm" value={ modalAddFactura.getIn(['data', 'valor_sin_iva']) || '' } onChange={ (e) => this.props.updateInputs('modalAddFactura.data.valor_sin_iva', e.target.value) } />
								</div>
                            </div>
                            <div className="col-md-3">
								<div className="form-group">
									<label className="control-label">Valor total</label>
									<input type="number" className="form-control input-sm" value={ modalAddFactura.getIn(['data', 'valor_con_iva']) || '' } onChange={ (e) => this.props.updateInputs('modalAddFactura.data.valor_con_iva', e.target.value) } />
								</div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        modalAddFactura: state.common.get('modalAddFactura'),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showHideModalAddFactura: (show) => dispatch(showHideModalAddFactura(show)),
		updateInputs: (path, value, immutable) => dispatch(updateInputs(path, value, immutable)),
        uploadFacturaFile: (file) => dispatch(uploadFacturaFile(file)),
        storeFactura: (last) => dispatch(storeFactura(last)),
        showHideModalLastFactura: (show, action) => dispatch(showHideModalLastFactura(show, action))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalAddFactura)


// WEBPACK FOOTER //
// ./src/components/Documentos/ModalAddFactura.jsx